/**
 * 매니저 통계 「현황」 탭(설계 §3-2) — 기준일 인원(ST2) 상자 둘: 학년별 막대 · 학교 × 학년 표(교차표).
 *   수강 기간(ST5) · 확인 필요(ST8) 상자는 만들지 않는다(오너 결정 2026-10-13, 백엔드 6단계 전달 §1 · §4-B).
 *   부서별 막대는 반 관리 화면의 「부서」로 옮겼다(오너 2026-10-10 「여기에 부서는 필요 없고」).
 * 인원은 휴원을 뺀 수다(오너 2026-10-10 「휴원은 전체 재원생에서 빼줘야 됨」) — 서버는 인원에 휴원을 넣고 따로 paused 를 준다(요청서 D6).
 * 상자마다 따로 실패한다 — 한 API 가 넘어져도 나머지 상자는 선다(설계 §8 「탭 하나 오류」의 상자 단위).
 */
import React from 'react';
import FloatingScrollArea from '../../common/FloatingScrollArea';
import { useAuth } from '../../../context/AuthContext';
import { getHeadcount } from '../academyApi';
import { Box, ErrorNotice, Spinner, useAcademyVersion, useAsync } from '../ui';
import { ColumnBars } from './charts';
import SchoolGradeTable from './SchoolGradeTable';

/** 상자 둘의 제목 · 부제 */
const BOXES = {
  grade: ['학년별 재원', '휴원 제외'],
  school: ['학교 × 학년', '휴원 제외'],
};

const settle = (p) => p.then((data) => ({ data }), (error) => ({ error }));

/** 넓으면 한 줄에 둘(백엔드 6단계 전달 §4-B) */
function OverviewTab({ asOf, wide, onOpenReport, schoolLevel, onSchoolLevelChange }) {
  const { getAccessToken } = useAuth();
  const version = useAcademyVersion();
  const res = useAsync((signal) => Promise.all([
    settle(getHeadcount({ asOf, groupBy: 'grade', signal }, getAccessToken)),
    settle(getHeadcount({ asOf, groupBy: 'school', splitBy: 'grade', signal }, getAccessToken)),
  ]), `overview-${asOf}-${version}`);

  const [grade, school] = res.data || [];
  const part = (r, render) => (res.error || r?.error ? <ErrorNotice error={res.error || r.error} onRetry={res.reload} compact /> : res.loading || !r?.data ? <Spinner label="현황 불러오는 중" compact /> : render(r.data));

  return (
    <div className={`grid gap-2 ${wide ? 'grid-cols-2' : 'grid-cols-1'}`}>
      <Box compact title={BOXES.grade[0]} sub={BOXES.grade[1]} right={onOpenReport && <button type="button" aria-label="학년별 통계 자세히" onClick={() => onOpenReport('headcount', { by: 'grade', as_of: asOf })} className="inline-flex min-h-6 items-center text-xs text-blue-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary">자세히</button>}>
        <FloatingScrollArea axis="y" className="h-24" aria-label="학년별 재원 현황">{part(grade, (d) => <ColumnBars compact ariaLabel="학년별 재원 인원" items={d.groups.map((g) => ({ label: g.label, value: g.count - (g.paused || 0) }))} />)}</FloatingScrollArea>
      </Box>
      <SchoolGradeTable compact groups={school?.data?.groups} loading={res.loading || !school} error={res.error || school?.error} onRetry={res.reload} levelValue={schoolLevel} onLevelChange={onSchoolLevelChange} onOpenDetail={onOpenReport && ((level) => onOpenReport('headcount', { by: 'school', as_of: asOf, school_level: level }))} />
    </div>
  );
}

export default OverviewTab;
